<template>
  <v-container>
    <!-- TÍTULO -->
    <v-row>
      <v-col cols="12">
        <h1 class="font-weight-medium">Estatísticas Gerais</h1>
        <!-- <h4 class="ml-3 grey--text">Período de 01/03/2024 à 07/03/2024</h4> -->
      </v-col>
    </v-row>

    <!-- FILTROS -->
    <v-row>
      <!-- Data Inicial -->
      <v-col cols="12" md="3">
        <v-menu
          v-model="menuDatePickerI"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <ValidationProvider #default="{ errors }" name="Data Inicial">
              <v-text-field
                v-model="data_inicial"
                label="Data Inicial"
                prepend-inner-icon="mdi-calendar"
                :error-messages="errors[0]"
                outlined
                v-bind="attrs"
                v-on="on"
              />
            </ValidationProvider>
          </template>
          <v-date-picker
            v-model="dataInicial"
            :active-picker.sync="ativarDatePicker"
            min="1900-01-01"
            locale="pt-BR"
          />
        </v-menu>
      </v-col>

      <!-- Data Final -->
      <v-col cols="12" md="3">
        <v-menu
          v-model="menuDatePickerF"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <ValidationProvider #default="{ errors }" name="Data final">
              <v-text-field
                v-model="data_final"
                label="Data final"
                prepend-inner-icon="mdi-calendar"
                :error-messages="errors[0]"
                outlined
                v-bind="attrs"
                v-on="on"
              />
            </ValidationProvider>
          </template>
          <v-date-picker
            v-model="dataFinal"
            :active-picker.sync="ativarDatePicker"
            min="1900-01-01"
            locale="pt-BR"
          />
        </v-menu>
      </v-col>

      <!-- Produto -->
      <v-col cols="12" md="3">
        <template>
          <v-combobox
            v-model="selected"
            :items="produtos"
            item-text="text"
            item-color="primary"
            item-value="value"
            label="Selecione os produtos"
            multiple
            chips
            outlined
            clearable
          >
            <template v-slot:selection="{ item, index }">
              <v-chip :key="index" :color="item.color" dark close @click:close="removeItem(item)">
                {{ item.text }}
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleSelectAll">
                <v-list-item-action>
                  <v-checkbox
                    :input-value="isAllSelected"
                    :indeterminate="isIndeterminate"
                    color="primary"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Selecionar todos</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
          </v-combobox>
        </template>
      </v-col>

      <!-- Checkbox Inativos -->
      <v-col cols="12" md="2">
        <v-checkbox v-model="situacao" label="Inativos" class="mt-2" hide-details />
      </v-col>

      <!-- Botão Pesquisar -->
      <v-col cols="12" md="2">
        <v-btn color="primary" height="55" width="100%" @click="listarEstatisticas()">
          <v-icon>mdi-magnify</v-icon>
          Pesquisar
        </v-btn>
      </v-col>
    </v-row>

    <!-- DASHBOARD -->
    <v-row>
      <v-col cols="12">
        <v-card color="#FBFBFB" elevation="0">
          <v-card-title class="text-h4 font-weight-medium">
            <v-icon class="mr-2 text-h4">mdi-chart-bar</v-icon>
            DASHBOARD GERAL
          </v-card-title>

          <v-row>
            <!-- TOTAL -->
            <v-col cols="12" md="4">
              <v-card class="pa-4 ml-2">
                <v-card-title class="d-flex justify-center">Total</v-card-title>
                <v-card-text class="d-flex flex-column align-center">
                  <GraficoRosca :chart-data="chartDataTotal" />
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in chartDataTotal.labels"
                      :key="index"
                      @click="abrirModal(item, index, -1)"
                    >
                      <v-list-item-icon>
                        <v-icon
                          :style="{ color: chartDataTotal.datasets[0].backgroundColor[index] }"
                        >
                          mdi-circle
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item }} : {{ chartDataTotal.datasets[0].data[index] }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>

              <CardInfo
                :value="totalAlunos"
                :action="true"
                :data="alunosAcademia(-1)"
                item="Alunos"
                :academiaId="1"
                :index="4"
                @abrir-modal="abrirModal"
                icon="mdi-account"
                text="Alunos: ativos"
                :corAvatar="coresAcademias.academia1.corAvatar"
              />
              <CardInfo
                :value="ticketMedio"
                icon="mdi-cash"
                text="Ticket Médio Total: ativos"
                :corAvatar="coresAcademias.academais.corAvatar"
              />
              <CardInfo
                :value="ltvTotal"
                icon="mdi-history"
                text="Ltv Total: ativos"
                :corAvatar="coresAcademias.academais.corAvatar"
              />
              <CardInfo
                :value="contratoTotal"
                icon="mdi-file-sign"
                text="Contratos totais gerados: No período"
                :corAvatar="coresAcademias.academais.corAvatar"
              />
            </v-col>

            <!-- ACADEMIA 1 -->
            <v-col cols="12" md="4">
              <v-card class="pa-4">
                <v-card-title class="d-flex justify-center">{{ silva }}</v-card-title>
                <v-card-text class="d-flex flex-column align-center">
                  <GraficoRosca :chart-data="chartDataAcademia1" />
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in chartDataAcademia1.labels"
                      :key="index"
                      @click="abrirModal(item, index, 1)"
                    >
                      <v-list-item-icon>
                        <v-icon
                          :style="{ color: chartDataAcademia1.datasets[0].backgroundColor[index] }"
                        >
                          mdi-circle
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item }} : {{ chartDataAcademia1.datasets[0].data[index] }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>

              <CardInfo
                :value="totalAlunosAcademia(this.indexSilva)"
                :action="true"
                :data="alunosAcademia(this.indexSilva)"
                item="Alunos"
                :academiaId="1"
                :index="4"
                @abrir-modal="abrirModal"
                icon="mdi-account"
                text="Alunos: ativos"
                :corAvatar="coresAcademias.academia1.corAvatar"
              />
              <CardInfo
                :value="ticketMedioAcademia(this.indexSilva)"
                icon="mdi-cash"
                text="Ticket Médio: ativos"
                :corAvatar="coresAcademias.academia1.corAvatar"
              />
              <CardInfo
                :value="ltvAcademia(this.indexSilva)"
                icon="mdi-history"
                text="Ltv: ativos"
                :corAvatar="coresAcademias.academia1.corAvatar"
              />
              <CardInfo
                :value="contratosAcademia(this.indexSilva)"
                icon="mdi-file-sign"
                text="Contratos gerados: No período"
                :corAvatar="coresAcademias.academia1.corAvatar"
              />
            </v-col>

            <!-- ACADEMIA 2 -->
            <v-col cols="12" md="4">
              <v-card class="pa-4 mr-2">
                <v-card-title class="d-flex justify-center">Medianeira</v-card-title>
                <v-card-text class="d-flex flex-column align-center">
                  <GraficoRosca :chart-data="chartDataAcademia2" />
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in chartDataAcademia2.labels"
                      :key="index"
                      @click="abrirModal(item, index, 2)"
                    >
                      <v-list-item-icon>
                        <v-icon
                          :style="{ color: chartDataAcademia2.datasets[0].backgroundColor[index] }"
                        >
                          mdi-circle
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item }} : {{ chartDataAcademia2.datasets[0].data[index] }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>

              <CardInfo
                :value="totalAlunosAcademia(this.indexMedianeira)"
                :action="true"
                :data="alunosAcademia(this.indexMedianeira)"
                item="Alunos"
                :academiaId="2"
                :index="4"
                @abrir-modal="abrirModal"
                icon="mdi-account"
                text="Alunos: ativos"
                :corAvatar="coresAcademias.academia2.corAvatar"
              />
              <CardInfo
                :value="ticketMedioAcademia(this.indexMedianeira)"
                icon="mdi-cash"
                text="Ticket Médio: ativos"
                :corAvatar="coresAcademias.academia2.corAvatar"
              />
              <CardInfo
                :value="ltvAcademia(this.indexMedianeira)"
                icon="mdi-history"
                text="Ltv: ativos"
                :corAvatar="coresAcademias.academia2.corAvatar"
              />
              <CardInfo
                :value="contratosAcademia(this.indexMedianeira)"
                icon="mdi-file-sign"
                text="Contratos gerados: No período"
                :corAvatar="coresAcademias.academia2.corAvatar"
              />
            </v-col>
          </v-row>

          <!-- GRÁFICO DE LINHA -->
          <v-card class="mt-5">
            <GraficoLinhaMulti :dados="[chartLinhaContratosSilva, chartLinhaContratosMedianeira]" />
          </v-card>

          <!-- GRÁFICO DE LINHA COMBINADO COM BARRAS -->
          <v-card class="mt-5" v-if="chartCombinadoLinhaBarrasTreinadores.length">
            <GraficoCombinado :dados="chartCombinadoLinhaBarrasTreinadores" />
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <div>
      <ModalLista
        v-model="modelValue"
        :titulo="getTituloModal"
        :dados="dadosModal"
        :itemKey="itemKey"
        :headers="colunasModal"
      />
    </div>
  </v-container>
</template>

<script>
const COLORS = {
  ENTRADAS: '#A0D995', // Verde claro pastel
  RENOVACOES: '#F5A17D', // Laranja claro pastel
  TRANSFERENCIAS: '#82C4E8', // Vermelho claro pastel
  SAIDAS: '#FF8A80', // Vinho claro pastel
  CONTRATOS: '#FF8F80', // Vinho claro pastel
};
const coresAcademias = {
  academais: {
    corLinha: '#FFB6C1', // Rosa pastel
    corAvatar: '#FFB347', // Rosa mais claro para o avatar
  },
  academia1: {
    corLinha: '#FFB6C1', // Rosa pastel
    corAvatar: '#FFDEE9', // Rosa mais claro para o avatar
  },
  academia2: {
    corLinha: '#87CEFA', // Azul pastel
    corAvatar: '#BFEFFF', // Azul mais claro para o avatar
  },
};
const LABELS = ['Entradas', 'Saídas', 'Transferências', 'Renovações'];
const BKGRDCOLOR = [COLORS.ENTRADAS, COLORS.SAIDAS, COLORS.TRANSFERENCIAS, COLORS.RENOVACOES];
import _relatoriosServico from '@/services/relatorios/relatorios-servico.js';
import util from '@/utils/utils.js';
// import GraficoBarras from "../AppGraficoBarra.vue"
import GraficoRosca from '../AppGraficoRosca.vue';
// import GraficoLinha from "../AppGraficoLinha.vue"
import GraficoLinhaMulti from '../AppGraficoLinhaMulti.vue';
import CardInfo from './CardInfo.vue';
import GraficoCombinado from '../AppGraficoCombinado.vue';
import produtos from '../../models/produtos';
import ModalLista from '../Modais/ListaModal.vue';

export default {
  components: {
    // GraficoBarras,
    GraficoRosca,
    GraficoCombinado,
    // GraficoLinha,
    GraficoLinhaMulti,
    ModalLista,
    CardInfo,
  },
  data() {
    return {
      selected: [],
      alunos: [],
      listaDados: [],
      coresAcademias,
      chartLinhaContratosSilva: [],
      chartLinhaContratosMedianeira: [],
      chartCombinadoLinhaBarrasTreinadores: [],
      produto: 0,
      produtos: produtos,
      modelValue: false,
      tituloModal: '',
      dadosModal: [],
      indexSilva: 0,
      itemKey: null,
      indexMedianeira: 1,
      colunasModal: [],
      chartDataTotal: {
        labels: LABELS,
        datasets: [
          {
            backgroundColor: BKGRDCOLOR,
            data: [],
          },
        ],
      },
      chartDataAcademia1: {
        labels: LABELS,
        datasets: [
          {
            backgroundColor: BKGRDCOLOR,
            data: [],
          },
        ],
      },
      chartDataAcademia2: {
        labels: LABELS,
        datasets: [
          {
            backgroundColor: BKGRDCOLOR,
            data: [],
          },
        ],
      },

      data_inicial: null,
      data_final: null,
      situacao: null,
      dataInicial: null,
      menuDatePickerI: false,
      dataFinal: null,
      menuDatePickerF: false,
      ativarDatePicker: null,
      cardSelecionado: null,
    };
  },

  async mounted() {
    // Criar uma nova data
    let dataAtual = new Date();

    // Definir o primeiro dia do mês
    let primeiroDia = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);

    // Definir o último dia do mês
    let ultimoDia = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);

    this.data_inicial = util.converterFormatoPtBr(primeiroDia.toISOString());
    this.data_final = util.converterFormatoPtBr(ultimoDia.toISOString());

    this.listarEstatisticas();
  },
  watch: {
    dataInicial() {
      this.data_inicial = util.converterFormatoPtBr(this.dataInicial);
    },
    dataFinal() {
      this.data_final = util.converterFormatoPtBr(this.dataFinal);
    },
  },
  computed: {
    isAllSelected() {
      return this.selected.length === this.produtos.length;
    },
    isIndeterminate() {
      return this.selected.length > 0 && !this.isAllSelected;
    },
    selectedValues() {
      return this.selected.map(item => item.value);
    },
    produtosComExtra() {
      // const extra = { text: 'Ac. Geral', value: -1, order: -1 };
      const extra = { text: 'Selecionar todos', value: 'ALL', order: -1 };

      // Copia e ordena os produtos pela prop "order"
      const produtosOrdenados = [...this.produtos].sort((a, b) => a.order - b.order);
      console.log([extra, ...produtosOrdenados]);
      // Adiciona o item extra no início, se necessário
      return [extra, ...produtosOrdenados];
    },
    getTituloModal() {
      return this.tituloModal;
    },
    totalAlunos() {
      return this.getSomaDados(this.listaDados, 'total');
    },
    ltvTotal() {
      const ltvTotal = this.getSomaDados(this.listaDados, 'ltv');
      const nrAcademias = this.listaDados.length;
      return ltvTotal > 0 ? ltvTotal / nrAcademias : 0;
    },
    contratoTotal() {
      return (
        this.getSomaDados(this.listaDados, 'entradas') +
        this.getSomaDados(this.listaDados, 'renovacoes')
      );
    },

    ticketMedio() {
      const ticketMedioTotal = this.getSomaDados(this.listaDados, 'ticket_academia');
      const nrAcademias = this.listaDados.length;
      return ticketMedioTotal > 0 ? ticketMedioTotal / nrAcademias : 0;
    },
    silva() {
      return 'Silva';
    },
    medianeira() {
      return 'Medianeira';
    },
  },

  methods: {
    selectedProdutos() {
      return this.selected.map(item => item.value);
    },
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selected = [];
      } else {
        this.selected = [...this.produtos];
      }
    },
    removeItem(item) {
      this.selected = this.selected.filter(i => i.value !== item.value);
    },

    alunosAcademia(index) {
      if (index === -1) {
        return this.listaDados
          .filter(obj => Array.isArray(obj.alunos) && obj.alunos.length > 0)
          .flatMap(obj => obj.alunos);
      }
      return this.listaDados?.[index]?.alunos ?? [];
    },
    totalAlunosAcademia(index) {
      return this.getDadosAcademia(index, 'total');
    },
    ltvAcademia(index) {
      return this.getDadosAcademia(index, 'ltv');
    },
    contratosAcademia(index) {
      return this.getDadosAcademia(index, 'entradas') + this.getDadosAcademia(index, 'renovacoes');
    },
    ticketMedioAcademia(index) {
      return this.getDadosAcademia(index, 'ticket_academia');
    },
    async abrirModal(item, index, academiaId, data = []) {
      const param = this.getItemModal(index);
      if (index <= 3) {
        const renovacao = index === 3 ? 2 : 0;
        var filtros = {
          data_de: util.formatarData(this.data_inicial),
          data_ate: util.formatarData(this.data_final),
          situacao: this.situacao ? 2 : 1,
          produtoArray: this.selectedProdutos(),
          academia_id: academiaId,
          renovacao: renovacao,
        };
      }
      this.dadosModal = index <= 3 ? await this.getDadosModal(filtros, param) : data;
      this.colunasModal = this.getColunasModal(index);
      this.tituloModal = `Detalhes: ${item}`;
      this.modelValue = true;
      this.itemKey = this.getItemKey(index);
    },

    getDadosAcademia(index, prop) {
      return this.listaDados?.[index]?.[prop] ? this.listaDados[index][prop] : 0;
    },
    getColunasModal(index) {
      switch (index) {
        case 0: //entradas
          return [
            { text: 'Início', value: 'data_inicial' },
            { text: 'Aluno', value: 'aluno' },
            { text: 'Treinador', value: 'treinador' },
            { text: 'Academia', value: 'academia' },
            { text: 'Produto', value: 'produto' },
            { text: 'Tipo', value: 'tipo_contrato' },
            { text: 'Acessar', value: 'aluno_id' },
          ];

        case 1: //saídas
          return [
            { text: 'Aluno', value: 'aluno' },
            { text: 'Treinador', value: 'treinador' },
            // { text: 'Academia ID', value: 'academia_id' },
            { text: 'Academia', value: 'academia' },
            { text: 'Produto', value: 'produto' },
            { text: 'Data inicial', value: 'data_inicial' },
            { text: 'Data final', value: 'data_final' },
            { text: 'Contrato', value: 'situacao_contrato' },
            { text: 'Motivo', value: 'motivo_saida' },
            { text: 'Acessar', value: 'usuario_id' },
          ];

        case 2: //transferencias
          return [
            { text: 'Aluno', value: 'aluno' },
            { text: 'Data inicial', value: 'data_inicial' },
            { text: 'Data final', value: 'data_final' },
            { text: 'Treinador', value: 'treinador' },
            { text: 'Academia', value: 'academia' },
            { text: 'Produto', value: 'produto' },
            { text: 'Tipo', value: 'tipo' },
            { text: 'Motivo', value: 'motivo' },
            { text: 'Acessar', value: 'aluno_id' },
          ];

        case 3: //renovacoes
          return [
            { text: 'Início', value: 'data_inicial' },
            { text: 'Aluno', value: 'aluno' },
            { text: 'Treinador', value: 'treinador' },
            { text: 'Academia', value: 'academia' },
            { text: 'Produto', value: 'produto' },
            { text: 'Tipo', value: 'tipo_contrato' },
            { text: 'Acessar', value: 'aluno_id' },
          ];

        case 4: //alunos
          return [
            { text: 'Início', value: 'data_inicial' },
            { text: 'Aluno', value: 'aluno' },
            { text: 'Treinador', value: 'treinador' },
            { text: 'Academia', value: 'academia' },
            { text: 'Produto', value: 'produto' },
            { text: 'Acessar', value: 'aluno_id' },
          ];

        default:
          return 'academia2';
      }
    },

    getDadosModal(filtros, param) {
      return _relatoriosServico.listarEstatisticasAcademia(filtros, param);
    },

    getItemModal(index) {
      switch (index) {
        case 0:
          return 'contratos';

        case 1:
          return 'saidas';

        case 2:
          return 'transferencias';

        case 3:
          return 'contratos';

        default:
          return 'academia2';
      }
    },
    getItemKey(index) {
      switch (index) {
        case 0:
          return 'aluno_id';

        case 1:
          return 'usuario_id';

        case 2:
          return 'aluno_id';

        case 3:
          return 'aluno_id';

        default:
          return 'aluno_id';
      }
    },
    async listarEstatisticas() {
      this.listaDados = [];
      var filtros = {
        data_de: util.formatarData(this.data_inicial),
        data_ate: util.formatarData(this.data_final),
        situacao: this.situacao ? 2 : null,
        produtoArray: this.selectedProdutos(),
      };
      this.chartCombinadoLinhaBarrasTreinadores = [];
      this.chartCombinadoLinhaBarrasTreinadores =
        await _relatoriosServico.listarEstatisticasTreinadores(filtros);

      _relatoriosServico.listarEstatisticas(filtros).then(response => {
        this.listaDados = response;
        this.atualizarGrafico();
      });
    },
    atualizarGrafico() {
      this.indexSilva = this.listaDados[0].academia_id == 1 ? 0 : 1;
      this.indexMedianeira = this.indexSilva == 0 ? 1 : 0;
      const indexSilva = this.indexSilva;
      const indexMedianeira = this.indexMedianeira;
      const academia1 = this.getDadosCharts(this.listaDados[indexSilva]);
      const academia2 = this.getDadosCharts(this.listaDados[indexMedianeira]);
      this.chartDataTotal.datasets[0].data = [
        academia1[0] + academia2[0],
        academia1[1] + academia2[1],
        academia1[2] + academia2[2],
        academia1[3] + academia2[3],
      ];
      const mesAtual = new Date().getMonth(); // 0 (jan) a 11 (dez)
      const mesesComZeros = Array.from({ length: mesAtual + 1 }, () => 0); //caso não tenha nenhum contrato, para comparar entre as academias
      this.chartLinhaContratosSilva = this.listaDados[indexSilva]?.contrato_mes
        ? this.listaDados[indexSilva].contrato_mes
        : mesesComZeros;
      this.chartLinhaContratosMedianeira = this.listaDados[indexMedianeira]?.contrato_mes
        ? this.listaDados[indexMedianeira].contrato_mes
        : mesesComZeros;
      this.chartDataAcademia1.datasets[0].data = academia1;
      this.chartDataAcademia2.datasets[0].data = academia2;
    },

    getDadosCharts(data) {
      return data
        ? [
            data.entradas ? data.entradas : 0,
            data.saidas ? data.saidas : 0,
            data.transferencias ? data.transferencias : 0,
            data.renovacoes ? data.renovacoes : 0,
          ]
        : [0, 0, 0, 0];
    },

    getSomaDados(data, prop) {
      return data.reduce((total, item) => total + (item[prop] || 0), 0);
    },
  },
};
</script>

<style scoped>
.v-avatar .v-icon {
  color: white !important;
}
</style>
